package com.ives.utils.math;

import haxe.ds.Vector;

class GeometryUtils {
	private static inline var EPSILON:Float = 0.000001;

	public static function doBoundingBoxesIntersect(a:Vector<Vector2D>, b:Vector<Vector2D>):Bool {
		return a[0].x <= b[1].x && a[1].x >= b[0].x && a[0].y <= b[1].y && a[1].y >= b[0].y;
	}

	public static function isPointOnLine(a:LineSegment, b:Vector2D):Bool {
		// Move the image, so that a.first is on (0|0)
		var aTmp:LineSegment = new LineSegment(new Vector2D(0, 0), new Vector2D(a.second.x - a.first.x, a.second.y - a.first.y));
		var bTmp:Vector2D = new Vector2D(b.x - a.first.x, b.y - a.first.y);
		var r:Float = aTmp.second.cross(bTmp);

		return Math.abs(r) < EPSILON;
	}

	public static function isPointRightOfLine(a:LineSegment, b:Vector2D):Bool{
		// Move the image, so that a.first is on (0|0)
		var aTmp:LineSegment = new LineSegment(new Vector2D(0, 0), new Vector2D(a.second.x - a.first.x, a.second.y - a.first.y));
		var bTmp:Vector2D = new Vector2D(b.x - a.first.x, b.y - a.first.y);

		return aTmp.second.cross(bTmp) < 0;
	}

	public static function xor(a:Bool, b:Bool):Bool{
		return (a && !b) || (!a && b);
	}

	public static function lineSegmentTouchesOrCrossesLine(a:LineSegment, b:LineSegment):Bool {
		return isPointOnLine(a, b.first) || isPointOnLine(a, b.second) || xor(isPointRightOfLine(a, b.first), isPointRightOfLine(a, b.second));
	}

	public static function doLinesIntersect(a:LineSegment, b:LineSegment):Bool {
		var box1:Vector<Vector2D> = a.getBoundingBox();
		var box2:Vector<Vector2D> = b.getBoundingBox();

		return doBoundingBoxesIntersect(box1, box2) && lineSegmentTouchesOrCrossesLine(a, b) && lineSegmentTouchesOrCrossesLine(b, a);
	}

	public static function vectorToPointCastToVector(point:Vector2D, vectorStart:Vector2D, vectorEnd:Vector2D):Vector2D{
		var d:Vector2D = vectorEnd.subtract(vectorStart);

		var result:Vector2D = null;

		if(d.length() == 0)
			result = new Vector2D(0, 0);
		else{
			d.normalize();

			var temp:Vector2D = point.subtract(vectorStart);
			var dist:Float = d.dot(temp);

			d.scale(dist);

			result = d;
		}

		return result;
	}
}
